export function updateTagInEvents(currentTag) {
  const eventsArr = $("#calendar").fullCalendar("clientEvents")
  const eventsArrUpdated = eventsArr.map(event => {
    if (!event.tags) return event
    return { ...event, tags: event.tags.map((t) => t.id === currentTag.id ? currentTag : t) }
  })
  $("#calendar").fullCalendar('updateEvents', eventsArrUpdated)
}

export function removeTagFromEvents(currentTag) {
  const eventsArr = $("#calendar").fullCalendar("clientEvents")
  const eventsArrUpdated = eventsArr.map(event => {
    if (!event.tags) return event
    return { ...event, tags: event.tags.filter(t => t.id !== currentTag.id) }
  })
  $("#calendar").fullCalendar('updateEvents', eventsArrUpdated)
}
